import { configureStore } from '@reduxjs/toolkit';

import BridgeUrlSlice from '../reducers/BridgeUrl';
import participantSlice from '../reducers/participantSlice';
import { confApi } from '../services/RttBridgeApi';


export const store = configureStore({

    reducer: {
        bridgeUrl: BridgeUrlSlice,
        participant: participantSlice,
        [confApi.reducerPath]: confApi.reducer,
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat([confApi.middleware]),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
